var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"archive--view"},[_c('img',{staticClass:"back__image",attrs:{"src":require("../assets/icons/back.svg")},on:{"click":_vm.backF}}),_c('iframe',{staticClass:"archive__video",attrs:{"src":_vm.src}})])}
var staticRenderFns = []

export { render, staticRenderFns }